module.exports = __webpack_public_path__ + "img/user.d91342d1.png";